var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1919 35.0625H7.82374C6.90901 35.0625 6.16797 34.321 6.16797 33.4066V6.71826C6.16797 5.80366 6.90913 5.0625 7.82374 5.0625H34.5123C35.4267 5.0625 36.168 5.80366 36.168 6.71826V33.4066C36.168 34.3211 35.4266 35.0625 34.5123 35.0625H26.8675V23.4448H30.767L31.3509 18.9172H26.8675V16.0267C26.8675 14.7158 27.2315 13.8225 29.1113 13.8225L31.5088 13.8215V9.77193C31.0942 9.71676 29.671 9.59348 28.0152 9.59348C24.5585 9.59348 22.1919 11.7035 22.1919 15.5783V18.9172H18.2824V23.4448H22.1919V35.0625Z",
    fill: "#4460A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookColor);
export default __webpack_public_path__ + "static/media/facebook-color.50f17acc6d4b5f9425c8e0afcb28bb79.svg";
export { ForwardRef as ReactComponent };